<template>
  <svg :class="className" :width="width" :height="height" :viewBox="viewBox" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.72712 0.884006C0.611463 1.55492 -0.537063 3.95348 0.247652 6.06274C0.510461 6.76924 0.793624 7.09247 3.78066 10.0951L7.02807 13.3594L10.2079 10.1591C13.8731 6.4702 14 6.28612 14 4.6546C14 3.83021 13.9395 3.50634 13.6891 2.99377C12.5194 0.599563 9.62992 -0.0552191 7.47919 1.58654C6.92285 2.01115 6.92234 2.01128 6.68731 1.75154C6.31325 1.33819 5.4845 0.915369 4.74946 0.762907C3.85849 0.578185 3.65329 0.590474 2.72712 0.884006ZM2.57658 2.0452C1.20813 2.72265 0.613895 4.50765 1.31604 5.83181C1.42063 6.0292 2.74671 7.42684 4.26275 8.93751L7.01911 11.6843L7.3435 11.3793C7.52194 11.2118 7.66801 11.0142 7.66801 10.9406C7.66801 10.8669 6.42949 9.56349 4.91574 8.04398L2.16348 5.28135V4.63489C2.16348 3.44809 3.06302 2.65275 4.17417 2.85719C4.5897 2.93361 5.05745 3.34222 7.41787 5.69086L10.176 8.43532L11.4038 7.18502C12.6793 5.88608 12.9177 5.45609 12.913 4.46259C12.9107 3.97934 12.5243 3.01797 12.1734 2.62254C12.0541 2.48813 11.6684 2.24286 11.3164 2.07746C10.2571 1.57988 9.22028 1.71737 8.36119 2.46944L7.86002 2.90813L8.19567 3.24993L8.53132 3.59185L9.07896 3.19514C10.3157 2.29931 11.8924 3.04664 11.8924 4.52864C11.8924 4.78326 11.8281 5.11724 11.7497 5.27111C11.5557 5.65118 10.3359 6.89482 10.1569 6.89482C10.0778 6.89482 8.98576 5.85062 7.73022 4.57434C6.24592 3.06572 5.26483 2.17104 4.9256 2.01691C4.21846 1.69586 3.25927 1.70738 2.57658 2.0452ZM3.40098 4.16393C3.09784 4.46694 3.45436 4.92356 5.90899 7.37602C7.3353 8.80118 8.54207 9.96711 8.59059 9.96711C8.63923 9.96711 8.82511 9.83154 9.00394 9.6659L9.32884 9.36469L6.75643 6.72162C4.6514 4.55898 4.12053 4.07855 3.83507 4.07855C3.64318 4.07855 3.44783 4.11695 3.40098 4.16393ZM9.67844 4.30552C9.47362 4.53184 9.4813 4.56295 9.82296 4.89028C10.1782 5.23066 10.1873 5.2322 10.4084 4.98782C10.5318 4.85136 10.6138 4.60532 10.5905 4.44108C10.5354 4.05116 9.98298 3.9691 9.67844 4.30552Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'CancelFlowsIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '14',
    },
    height: {
      type: String,
      default: '14',
    },
    viewBox: {
      type: String,
      default: '0 0 14 14',
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
};
</script>
